import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dragMore",
  "use": "icon-dragMore-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dragMore\"><path d=\"M465.455 837.818V1024H279.273V837.818h186.182zm279.272 0V1024H558.545V837.818h186.182zM465.455 558.545v186.182H279.273V558.545h186.182zm279.272 0v186.182H558.545V558.545h186.182zM465.455 279.273v186.182H279.273V279.273h186.182zm279.272 0v186.182H558.545V279.273h186.182zM465.455 0v186.182H279.273V0h186.182zm279.272 0v186.182H558.545V0h186.182z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol